import React from 'react';
import { arraySpacingX as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const ArraySpacingX = (props) => {
  const name = 'array_spacing_x';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Spacing X"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArraySpacingX.defaultProps = {};

export default ArraySpacingX;
